import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Typography
} from '@mui/material';

import AppDisplay from '../ui/AppDisplay';
import SubscriptionBusinessModelDisplay from '../ui/SubscriptionBusinessModelDisplay';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
        //marginTop: 10,
    },
    flex: {
      flex: 1,
    },
    paper1: {
      padding: theme.spacing(3),
      textAlign: 'left',
      marginTop: 16,
      maxWidth: 980
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: theme.spacing(1),
      marginTop: -16,
    }
});

class CustomerBindCardProvision extends Component {
    setAppCreateStateBcUser = (aKey, aValue) => {
      this.props.setAppCreateStateBcUser(aKey, aValue);
    };

    componentDidMount() {
      if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription create (confirmation step)'); }
    }

    isCardAddressAppBindCorporate(address1, address2, city, state, postalCode, country) {
      if (this.props.appBindAddress === null) {
        return false;
      }
      if (this.props.appBindAddress.address1 !== address1) {
        return false;
      }
      if (this.props.appBindAddress.address2 !== address2) {
        return false;
      }
      if (this.props.appBindAddress.city !== city) {
        return false;
      }
      if (this.props.appBindAddress.state !== state) {
        return false;
      }
      if (this.props.appBindAddress.country !== country) {
        return false;
      }
      if (this.props.appBindAddress.postalCode !== postalCode) {
        return false;
      }
      return true;
     }

    render() {
      const classes = this.props.classes;

      let expensingActive = false;
      let expensing = abEnvironment.getFlagValue("expensing");
      if (expensing != null && expensing.flagValue === 1) {
        expensingActive = true;
      }

      if (expensingActive === true) {
        let theTitleLine = '';
        if (this.props.cApp.appName === this.props.cApp.appSku || this.props.cApp.appSku == null || this.props.cApp.appSku === '')
          theTitleLine = this.props.cApp.appName;
        else
          theTitleLine = this.props.cApp.appName + " (" + this.props.cApp.appSku + ")";

        let confirmStatement = ""

        // Name/Address
        let billingFirstName  = this.props.pbcUser.firstName;
        let billingLastName   = this.props.pbcUser.lastName;
        let billingAddress1   = this.props.pbcUser.address1;
        let billingAddress2   = this.props.pbcUser.address2;
        let billingCity       = this.props.pbcUser.city;
        let billingState      = this.props.pbcUser.state;
        let billingCountry    = this.props.pbcUser.country;
        let billingPostalCode = this.props.pbcUser.postalCode;

        // Who is it for?
        let billingAddressLabel;
        let usingAccount = this.props.bcUser.accountName;
        if (usingAccount === abEnvironment.getUserAttribute('a_accountName')) {
          billingAddressLabel = "My billing address";
          confirmStatement = confirmStatement + "Confirm: I am buying " + theTitleLine + " for me (" + usingAccount + ")";
        } else {
          confirmStatement = confirmStatement + "Confirm: I am buying " + theTitleLine + " for " + usingAccount;
          billingAddressLabel = "My billing address";

          // If not bill to me, use the customer info
          if (this.props.cApp.paymentOrder !== 2) {
            billingAddressLabel = "Billing address for " + usingAccount;
            billingFirstName = this.props.bcUser.firstName;
            billingLastName = this.props.bcUser.lastName;

            // If the customer address exists now, show it.
            // Otherwise, keep the reseller address for now.
            if (this.props.bcUser.address1   != null && this.props.bcUser.address1   !== '' &&
                this.props.bcUser.city       != null && this.props.bcUser.city       !== '' &&
                this.props.bcUser.country    != null && this.props.bcUser.country    !== '' &&
                this.props.bcUser.postalCode != null && this.props.bcUser.postalCode !== '' ) {
              billingAddress1   = this.props.bcUser.address1;
              billingAddress2   = this.props.bcUser.address2;
              billingCity       = this.props.bcUser.city;
              billingState      = this.props.bcUser.state;
              billingCountry    = this.props.bcUser.country;
              billingPostalCode = this.props.bcUser.postalCode;
            }
          }
        }
        
        if (billingCountry !== 'US' && this.props.appBindAddress) {
          billingAddress1   = this.props.appBindAddress.address1;
          billingAddress2   = this.props.appBindAddress.address2;
          billingCity       = this.props.appBindAddress.city;
          billingState      = this.props.appBindAddress.state;
          billingCountry    = this.props.appBindAddress.country;
          billingPostalCode = this.props.appBindAddress.postalCode;
        }

        let showAppBindAddressTip = false;
        if (this.isCardAddressAppBindCorporate(billingAddress1, billingAddress2, billingCity, billingState, billingPostalCode, billingCountry)) {
          showAppBindAddressTip = true;
        }

        let cityState = billingCity;
        if (billingState != null && billingState !== '') {
          cityState = cityState + ', ' + billingState;
        }

        // Determine the address to show
        // - If the app is "for me", show the bcUser values (which will be same as pbcUser values)
        // - If the app is for cust, expense to me, show the pbcUser values
        // - If the app is for cust, expense to cust, don't show an address
        //   - we won't have one yet, but will get one when the customer provides it

        return (
          <Paper className={classes.paper1}>
            <Grid container spacing={2} direction="row" justifyContent="flex-start">
              <Grid item xs={12}>
                <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
                  {confirmStatement}
                </Typography>
              </Grid>
              
              <Grid item xs={12}>
                <AppDisplay appLogo={this.props.cApp.appLogo}
                            appName={this.props.cApp.appName}
                            appSku={this.props.cApp.appSku}
                            description={this.props.cApp.description}/>
              </Grid>
              <Grid item xs={12}>
                  <SubscriptionBusinessModelDisplay paymentOrder={this.props.cApp.paymentOrder}
                                      accountName={this.props.bcUser.accountName}
                                      appMarkupPercentage={this.props.cApp.appMarkupPercentage}
                                      wholesaleDiscountPercentage={this.props.cApp.wholesaleDiscountPercentage}
                                      passThroughFees={this.props.cApp.passThroughFees}
                                      showSubscription={this.props.cApp.showSubscription}
                                      usingAccountId={this.props.bcUser.usingAccountId}/>
              </Grid>
              { this.props.cApp.notes != null && this.props.cApp.notes !== '' &&
              <Grid item xs={12}>
                <Typography variant="body1">My notes: {this.props.cApp.notes}</Typography>
              </Grid>
              }

              {billingAddress1 &&
                <React.Fragment>
                  <Grid item xs={12}>
                    <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                      {billingAddressLabel}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" data-recording-sensitive>
                      {billingFirstName} {billingLastName} 
                    </Typography>
                    <Typography variant="body1" data-recording-sensitive>
                      {billingAddress1} {billingAddress2} 
                    </Typography>
                    <Typography variant="body1" data-recording-sensitive>
                      {cityState} 
                    </Typography>
                    <Typography variant="body1" data-recording-sensitive>
                      {billingCountry} {billingPostalCode}
                    </Typography>
                  </Grid>
                </React.Fragment>
              }
              {showAppBindAddressTip &&
                <Grid item xs={12}>
                  <Paper elevation={1} style={AppBindStyles.tipPaper}>
                    <Grid container spacing={1} direction="row" justifyContent="flex-start">
                    <Grid item xs={12}>
                        <div style={{display:"flex"}}>
                          <Typography variant="body1">
                            <strong>Tip.&nbsp;&nbsp;</strong>We’re using this address because AppBind virtual cards are issued from the United States.
                          </Typography>
                        </div>
                      </Grid>      
                    </Grid>
                  </Paper>
                </Grid>
              }

            </Grid>
          </Paper>
        );
      }

      // Expensing not active
      let theTitleLine = '';
      if (this.props.cApp.appName === this.props.cApp.appSku || this.props.cApp.appSku == null || this.props.cApp.appSku === '')
        theTitleLine = this.props.cApp.appName;
      else
        theTitleLine = this.props.cApp.appName + " (" + this.props.cApp.appSku + ")";

      let confirmStatement = ""

      // Who is it for?
      let usingAccount = this.props.bcUser.accountName;
      if (usingAccount === abEnvironment.getUserAttribute('a_accountName')) {
        confirmStatement = confirmStatement + "Confirm: I am adding " + theTitleLine + " for me (" + usingAccount + ")";
      } else {
        confirmStatement = confirmStatement + "Confirm: I am adding " + theTitleLine + " for " + usingAccount;
      }

      return (
        <Paper className={classes.paper1}>
          <Grid container spacing={2} direction="row" justifyContent="flex-start">
            <Grid item xs={12}>
              <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
                {confirmStatement}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <AppDisplay appLogo={this.props.cApp.appLogo}
                          appName={this.props.cApp.appName}
                          appSku={this.props.cApp.appSku}
                          description={this.props.cApp.description}/>
            </Grid>
            { this.props.cApp.notes != null && this.props.cApp.notes !== '' &&
            <Grid item xs={12}>
              <Typography variant="body1">My notes: {this.props.cApp.notes}</Typography>
            </Grid>}
          </Grid>
        </Paper>
      );
    }
}

CustomerBindCardProvision.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(CustomerBindCardProvision);
